<template>
    <section class="card" :class="design">
        <section class="header">
            <div v-if="icon" class="icon">
                <em :class="icon"/>
            </div>
			<div v-if="dynamicIcon" class="icon">
				<component
					:is="dynamicIcon"
					:fill="'#2084E5'"
					:width="widthDynamicIcon"
					:height="heightDynamicIcon"
				/>
			</div>
            <div class="title">
                {{title}}
            </div>
        </section>
        <section v-if="text" class="text" v-html="text"/>
        <section class="body" :class="classComputed">
            <slot name="body" />
        </section>
        <section v-if="obs" class="obs" v-html="obs"/>
        <slot v-if="selectionBar" name="selectionBar"/>
        <section v-if="isFooterLeft || isFooterRight" class="footer">
            <div v-if="isFooterLeft">
                <slot name="fl" />
            </div>
            <div v-if="isFooterRight">
                <slot name="fr" />
            </div>
        </section>
    </section>
</template>

<script>
export default {
	props: {
		icon: {},
		title: {},
		text: {},
		obs: {},

		design: {
			type: String,
			default: ''
		},

		// Classes de estilos.
		pOff: {
			type: Boolean,
			default: false
		},
		dynamicIcon: {
			type: String,
			required: false,
			default: false
		},
		widthDynamicIcon:{
			type: [String, Number],
			default: 26
		},
		heightDynamicIcon:{
			type: [String, Number],
			default: 23
		},
        selectionBar: {
            type: Boolean,
            default: false,
            required: false
        }
	},
    computed: {
		isFooterLeft(){
			return this.$slots['fl'] ? true : false
		},
		isFooterRight(){
			return this.$slots['fr'] ? true : false
		},

		classComputed(){
			return {
				'p-off': this.pOff,
			}
		}
	},
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>